import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Col, Row } from 'react-bootstrap';

import FlatButton from 'material-ui/FlatButton';
import Dialog from 'material-ui/Dialog';
import Snackbar from 'material-ui/Snackbar';
import { blue800 } from 'material-ui/styles/colors';
import PlayIcon from 'material-ui/svg-icons/av/play-circle-outline';
import { Grid } from "@material-ui/core";

import Campaigns from './campaigns';

import { getAllCampaigns } from '../../reducers/campaign/resources';
import mixpanel from '../../utils/mixpanel';

import './index.css';

class CampaignContacts extends Component {
	componentWillMount = async () => {
		this.setState({
			campaigns: [],
			groups: [],
			importGroups: [],
			assignedBots: [],
			file: [{ name: '' }],
			campaignId: '',
			groupId: '',
			botmapId: '',
			importCampaignId: '',
			importGroupId: '',
			botName: '',
			template: '',
			scheduleDateTime: '',
			showImportModal: false,
			showSnackBar: false,
			snackBarMessage: '',
			introDialog: false
		});

		const campaigns = await getAllCampaigns();

		this.setState({
			campaigns: campaigns.data
		});
	};

	handleClose = () =>
		this.setState({
			showSnackBar: false,
			snackBarMessage: ''
		});

	closeIntroDialog = () => {
		this.setState({ introDialog: false });
	};

	openIntroDialog = () => {
		this.setState({
			introDialog: true
		});
	};

	render = () => {
		let styles = {
			gridFluid: {
				height: '100%',
				backgroundColor: 'white',
				overflowY: 'auto',
				paddingBottom: '30px'
			},
			searchFilter: {
				padding: '0 15px 10px',
				marginBottom: '5px'
			},
			searchFilterContainer: {},
			raisedButton: {
				marginTop: '10px'
			},
			spacer: {
				marginLeft: '5px',
				marginRight: '5px'
			}
		};
		return (
      <Grid fluid className="sitewide-grid-container">
        <Snackbar
          open={this.state.showSnackBar}
          message={this.state.snackBarMessage}
          autoHideDuration={4000}
          onRequestClose={this.handleClose}
          bodyStyle={{
            height: 'auto',
            lineHeight: '28px',
            whiteSpace: 'pre-line',
          }}
        />
		<div className="sitewide-page-container">
			<Row className="pt-50">
				<Col xs={12} className="text-center">
					<img src="assets/images/broadcast-icon.jpg" alt="broadcast" />
					<h1>Welcome to Broadcast Messaging</h1>
					<p>
					Easily send customized messages to hundreds or thousands of
					contacts in 3 Easy Steps.
					</p>
					{/* <FlatButton
					label="View Introduction Video"
					icon={<PlayIcon color={blue800} />}
					className="video-link"
					onClick={() => {
						mixpanel.track('broadcast campaign:view introduction video')
					}}
					/> */}
				</Col>
			</Row>
			<Row>
				<Col xs={4} xsOffset={4}>
					<div  className="gh-notif-warning">
					 <strong>Notice:</strong>Your account is currently limited to 1000 contacts per campaign.
					</div>
				</Col>
			</Row>
			<Dialog
				title="Welcome to Broadcast Messaging"
				autoScrollBodyContent={true}
				modal={false}
				open={this.state.introDialog}
				onRequestClose={this.closeIntroDialog}
			>
				{/* <ResponsiveEmbed a16by9></ResponsiveEmbed> */}
			</Dialog>
			<Campaigns />
		</div>
       
      </Grid>
    )
	};
}

const mapStateToProps = state => {
	return {};
};

const mapDispatchToProps = dispatch => {
	return {};
};

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(CampaignContacts);
